<script setup lang="ts"></script>

<template>
  <div class="dropdown-divider"></div>
</template>

